/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

    Product Plugin Scroll Animation

    Helpful course: https://ihatetomatoes.net/module-1/pin-html-css-855/

*/

import ScrollMagic from 'scrollmagic';
import 'debug.addIndicators';

$(function () {

    const controller = new ScrollMagic.Controller({
        // addIndicators: true
        globalSceneOptions: {
            triggerHook: 'onLeave'
        }
    });
    const $productImages = document.querySelectorAll('.product__images__item');
    const $productTitles = document.querySelectorAll('.product__titles__container');
    const $productTexts = document.querySelectorAll('.product__texts__item');
    const isMobile = $(window).width() < 768;

    if ($productImages.length && $productTitles.length) {
        new ScrollMagic.Scene({
            triggerElement: $productImages[0],
            triggerHook: 0,
            duration: `${isMobile ? $productImages.length + 2 : $productImages.length - 1}00%`, // 100% x productItems.length
        })
        .setPin($productTitles, {pushFollowers: true})
        // .addIndicators({name: 'titles'}) // add indicators (requires plugin)
        .addTo(controller);

        // calculate product text items spacing
        const textsHeight = Array.from($productTexts).reduce((total, element) => total + $(element).outerHeight(), 0);
        for (let index = 0; index < $productTexts.length; index++) {
            $($productTexts[index]).css('margin-top', ($('.product__images').height() - textsHeight) / $productTexts.length);
        }

        for (let index = 0; index < $productImages.length; index++) {
            const element = $productImages[index];
            let triggerElement = null;
            let duration = isMobile ? '150%' : '100%';

            if (index <= 1) {
                // second element must be triggered by first element
                triggerElement = $productImages[0];
            } else {
                // the other elements must be triggered by the one before
                triggerElement = $productImages[index - 1];
            }
            if (index > 0 && index < $productImages.length - 1) {
                // must overlay next element to have the clipping effect, except first and last element
                duration = isMobile ? '300%' : '200%';
            }

            new ScrollMagic.Scene({
                triggerElement,
                triggerHook: 0,
                duration,
            })
            .setPin(element.querySelector('.pin-wrapper'))
            .addTo(controller)
            // .addIndicators({ name: `product ${index + 1}`})
            .on("progress", function (event) {
                // animate titles on scroll progress
                if ($productImages.length === 2) {
                    if (event.progress > 0.5) {
                        $('.product__titles__item').first().removeClass('product__titles__item--active');
                        $('.product__titles__item').last().addClass('product__titles__item--active');
                    } else {
                        $('.product__titles__item').first().addClass('product__titles__item--active');
                        $('.product__titles__item').last().removeClass('product__titles__item--active');
                    }
                } else {
                    if (event.progress > 0.25) {
                        $('.product__titles__item').removeClass('product__titles__item--active');
                        $(`.product__titles__item--${index + 1}`).addClass('product__titles__item--active');
                    }
                    else {
                        if (index > 0 && index < $productImages.length) {
                            $('.product__titles__item').removeClass('product__titles__item--active');
                            $(`.product__titles__item--${index}`).addClass('product__titles__item--active');
                        }
                    }
                }
            })
            ;
        }
    }

});



// WEBPACK FOOTER //
// ./static/js/modules/product.js